<template>
    <b-modal v-model="show" :title="$t('auto.taxesAdd')" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Солиқлар <span class="red">*</span></label>
                        <select class="form-control" v-model="dictionaryData.data.limitType" :class="{invalid : $v.dictionaryData.data.limitType.$error}">
                            <option value=""></option>
                            <option :value="option.key" v-for="option in limitTypes" :key="option.key">{{option.name}}</option>
                        </select>
                        <div class="red" v-if="$v.dictionaryData.data.limitType.$error">Солиқлар</div>
                    </div>
                    <div class="form-group">
                        <label>Қиймати <span class="red">*</span></label>
                        <numeric-input v-model="dictionaryData.data.rate" :precision="2" :class="{invalid : $v.dictionaryData.data.rate.$error}"></numeric-input>
                    </div>
                    <div class="red" v-if="$v.dictionaryData.data.rate.$error">Қиймати</div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import {numericTypes} from '@/shared/constants/mask'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {clone} from '@/shared/utils';
    import { required } from 'vuelidate/lib/validators'
    import {LIMIT_TYPES} from '@/shared/constants/auto'
    export default {
        name: "DiscountLimitEditModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                numericTypes: numericTypes,
                dictionaryData: {
                    id: null,
                    dictionaryType: 'DISCOUNT_LIMIT',
                    data: {
                        limitType: null,
                        rate: null
                    }
                },
                limitTypes: LIMIT_TYPES,
            }
        },
        validations: {
            dictionaryData: {
                data: {
                    rate: {
                        required
                    },
                    limitType: {
                        required
                    }
                }
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },
            save() {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;

                this.$http.post('dictionary/save', this.dictionaryData)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('taxChanged', response);
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            }
        },
        created() {
            this.$eventBus.$on('DiscountLimitEditModal', (data) => {
                if (data) {
                    this.dictionaryData.id = data.id;
                    this.dictionaryData.data = clone(data.data);
                } else {
                    this.dictionaryData.id = null;
                    this.dictionaryData.data = {
                        limitType: null,
                        rate: null
                    };
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>